import { buildSingleAccessRuleRequest } from "./accessRuleRequestBuilder";
import { BaseAccessRuleRequestParams } from "./accessRuleRequestMapper";

export type MapAccessRuleChangeRequestParams = BaseAccessRuleRequestParams & {
  entitlementTypeId: number;
  fulfillmentSeasonId: number;
  liftAccessRuleScopeCategoryId: number;
  liftAccessRuleScopeEntityId: number;
};

// Assumes validation has already been done and all required fields are present and valid
export function mapAccessRuleChangeRequest(
  params: MapAccessRuleChangeRequestParams,
) {
  const {
    userId,
    operatorId,
    entitlementTypeId,
    fulfillmentSeasonId,
    liftAccessRuleScopeCategoryId,
    liftAccessRuleScopeEntityId,
    changeSet,
  } = params;

  const context = {
    EntitlementTypeId: entitlementTypeId,
    FulfillmentSeasonId: fulfillmentSeasonId,
    LiftAccessRuleScopeCategory: liftAccessRuleScopeCategoryId,
    LiftAccessRuleScopeEntityId: liftAccessRuleScopeEntityId,
  };

  return buildSingleAccessRuleRequest({
    userId,
    operatorId,
    context,
    changeSet,
  });
}
